import PropTypes from 'prop-types'
import { usePolicy } from '../../hooks/usePolicy'

function WithPolicy ({ policy, fallback, children }) {
  const available = usePolicy(policy)

  if (available) {
    return children
  }

  return typeof fallback === 'function' ? fallback() : fallback || null
}

WithPolicy.propTypes = {
  policy: PropTypes.string,
  children: PropTypes.node,
  fallback: PropTypes.node
}

WithPolicy.defaultProps = {
  fallback: null
}

export default WithPolicy
